module.exports = __webpack_public_path__ + "img/Jose-Lopez-Taboada.590e7ec8.jpg";